import validate from "/codebuild/output/src1569322956/src/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/codebuild/output/src1569322956/src/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  authenticated: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/middleware/authenticated.ts"),
  onboarding: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/middleware/onboarding.ts"),
  verify: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/middleware/verify.ts"),
  "sidebase-auth": () => import("/codebuild/output/src1569322956/src/repo/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}